import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { ControlInfo, getControlInfo } from 'owa-mail-ribbon-utils';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import { onCreateRuleClicked, onManageRulesClicked } from '../../util/commandActions';
import { createMailAppButton } from '../../util/createMailRibbonButton';

export default function getRulesSections(): MenuSection[] {
    return [{ controls: getRulesControls() }];
}

function getRulesControls(): MenuItemControlProps[] {
    const controls: MenuItemControlProps[] = [];
    const createRuleControlInfo: ControlInfo = getControlInfo(MailRibbonControlId.CreateRule);
    const manageRulesControlInfo: ControlInfo = getControlInfo(MailRibbonControlId.ManageRules);

    controls.push(
        createMailAppButton(
            MailRibbonControlId.CreateRule,
            createRuleControlInfo.text,
            createRuleControlInfo.tooltip,
            false /*isPopout*/,
            onCreateRuleClicked,
            constructKeytip(
                [
                    getKeytipString(MailRibbonTabId.Tab_Home),
                    getKeytipString(MailRibbonControlId.Rules),
                ],
                getKeytipString(MailRibbonControlId.CreateRule)
            ),
            createRuleControlInfo.iconName
        )
    );

    controls.push(
        createMailAppButton(
            MailRibbonControlId.ManageRules,
            manageRulesControlInfo.text,
            manageRulesControlInfo.tooltip,
            false /*isPopout*/,
            onManageRulesClicked,
            constructKeytip(
                [
                    getKeytipString(MailRibbonTabId.Tab_Home),
                    getKeytipString(MailRibbonControlId.Rules),
                ],
                getKeytipString(MailRibbonControlId.ManageRules)
            ),
            manageRulesControlInfo.iconName
        )
    );

    return controls;
}
